<script setup lang="ts">
type Props = {
  title?: string;
  onBack?: AccountMenu.Groups;
  isWalletPage?: boolean;
  showUserMenu?: boolean;
};

const {
  title,
  onBack,
  isWalletPage = false,
  showUserMenu = true,
} = defineProps<Props>();
</script>

<template>
  <ClientOnly>
    <UserAccountProtectionAlertOnlyWithdraw />

    <div :class="$style.userPageContainer">
      <div :class="$style.userPageWrapper">
        <div
          v-if="showUserMenu"
          :class="[$style.leftPage, { [$style.isWalletPage]: isWalletPage }]"
        >
          <UserMenu />
        </div>

        <div :class="$style.rightPage">
          <UserPageAccountTitle
            v-if="title"
            :on-back="onBack || undefined"
            :title="title"
          />

          <slot />
        </div>
      </div>
    </div>
  </ClientOnly>
</template>

<style module lang="scss">
.userPageContainer {
  @apply p-0;

  .userPageWrapper {
    @apply mb-5 md:mb-8 flex items-start justify-center gap-4 flex-col-reverse lg:flex-row;

    .leftPage {
      @apply flex-1 w-full max-w-full lg:max-w-[300px] hidden md:block;

      &.isWalletPage {
        @apply block;
      }
    }

    .rightPage {
      @apply flex-1 w-full flex flex-col gap-4 overflow-visible lg:overflow-auto;
    }
  }
}
</style>
